import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-banner-alert',
  templateUrl: './banner-alert.component.html',
  styleUrls: ['./banner-alert.component.scss'],
})
export class BannerAlertComponent implements OnInit {
  @Input() showBannerNotification: boolean = false;
  @Input() showBannerInvoice: boolean = false;
  @Input() disableButton: boolean = false;

  @Output() emitClickResendButton = new EventEmitter<boolean>();

  keyTranslate: string = 'shared.banner-alert';

  constructor() {}

  ngOnInit(): void {}

  emitOnClick() {
    this.emitClickResendButton.emit(true);
  }
}
